/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import objectPath from "object-path";
import React, { useEffect, useLayoutEffect, useMemo } from "react";
import { useLocation, Link } from "react-router-dom";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { getBreadcrumbsAndTitle, useSubheader } from "../../_core/MetronicSubheader";
import { makeStyles, Menu, MenuItem, TextField } from "@material-ui/core";
import AuthService from "../../../../app/base/services/authentication.service";
import { UserRolesEnum } from "../../../../app/pages/auth/userRoles.enum";

const useStyles = makeStyles((theme) => ({
   container: {
      display: "flex",
      flexWrap: "wrap"
   },
   textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1)
   }
}));

export function SubHeader() {
   const uiService = useHtmlClassService();
   const location = useLocation();
   const subheader = useSubheader();
   const classes = useStyles();
   const [anchorEl, setAnchorEl] = React.useState(null);
   const user = AuthService.getUser();


   function handleClick(event) {
      setAnchorEl(event.currentTarget);
   }

   function handleClose() {
      setAnchorEl(null);
   }

   const layoutProps = useMemo(() => {
      return {
         config: uiService.config,
         subheaderFixed: objectPath.get(uiService.config, "subheader.fixed"),
         subheaderMobileToggle: objectPath.get(uiService.config, "subheader.mobile-toggle"),
         subheaderCssClasses: uiService.getClasses("subheader", true),
         subheaderContainerCssClasses: uiService.getClasses("subheader_container", true)
      };
   }, [uiService]);

   useLayoutEffect(() => {
      const aside = getBreadcrumbsAndTitle("kt_aside_menu", location.pathname);
      const header = getBreadcrumbsAndTitle("kt_header_menu", location.pathname);
      const breadcrumbs =
         aside && aside.breadcrumbs.length > 0 ? aside.breadcrumbs : header.breadcrumbs;
      subheader.setBreadcrumbs(breadcrumbs);
      subheader.setTitle(
         aside && aside.title && aside.title.length > 0 ? aside.title : header.title
      );

      // eslint-disable-next-line
   }, [location.pathname]);

   // Do not remove this useEffect, need from update title/breadcrumbs outside (from the page)
   useEffect(() => {}, [subheader]);

   return (
      <div
         id="kt_subheader"
         className={`subheader py-2 py-lg-4 ${layoutProps.subheaderCssClasses}`}
      >
         <div
            className={`${layoutProps.subheaderContainerCssClasses} d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap`}
         >
            {/* Search Input Bar */}
            {/* <div className="subheader-search-bar">
               <TextField
                  id="outlined-search-input"
                  label="Search"
                  className={classes.textField + " search-input disabled"}
                  type="text"
                  name="search"
                  variant="outlined"
                  size="small"
               />
            </div> */}

            <div className="d-flex align-items-center flex-wrap mr-1">
               {/* begin::Mobile Toggle */}
               {layoutProps.subheaderMobileToggle && (
                  <button
                     className="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none"
                     id="kt_subheader_mobile_toggle"
                  >
                     <span />
                  </button>
               )}
               {/* end::Mobile Toggle */}
            </div>
            <div className="subheader-rigth d-flex align-items-center">
               <div className="user-info mr-2">
                  {user?.fullName}
                  <br />
                  {user?.roles[0]?.name}
               </div>
               <button
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                  className="btn btn-icon font-weight-bolds top-profile-btn"
                  data-toggle="modal"
                  data-target="#kt_chat_modal"
               >
                  <span className="user-letter">L</span>
               </button>
               
               <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
               >
                   {AuthService.isAuthorized([
                      UserRolesEnum.NationalOrganization,
                      UserRolesEnum.InternationalOrganization]) && location.pathname !== "/admin/workspace" &&(
                      <Link to="/admin/workspace">
                         <MenuItem>Change workspace</MenuItem>
                      </Link>
                   )}
                   {AuthService.isAuthorized([UserRolesEnum.SuperAdmin, UserRolesEnum.Manager, UserRolesEnum.Consultant,UserRolesEnum.Donor, UserRolesEnum.Staff]) && (

                     <Link to="/admin/workspace">
                        <MenuItem>Change workspace</MenuItem>
                     </Link>
                   )}
                 
                   
                  {AuthService.isAuthorized([
                     UserRolesEnum.NationalOrganization,
                     UserRolesEnum.InternationalOrganization
                  ]) && (
                     <Link to={`/organization-management/details/${user.organizationId}`}>
                        <MenuItem>My profile</MenuItem>
                     </Link>
                  )}
               </Menu>
            </div>
         </div>
      </div>
   );
}
